import colors from '../../configuration/colors'

const light = {
  style: 'light',
  text: '#363537',
  cardBackground: colors.white,
  mentorCard: '#F8F8F8',
  h1: colors.victoria,
  h2: colors.victoria,
  h3: colors.victoria,
  h4: colors.charcoal4,
  h5: colors.victoria,
  h6: colors.victoria,
  p1: colors.victoria,
  p2: colors.charcoal4,
  p3: colors.victoria,
  caption1color: colors.dove,
  caption2color: colors.white,
  caption3color: colors.victoria,
  caption4color: colors.dove,
  caption5color: colors.dove,
  caption6color: colors.dove,
  caption7color: colors.dove,
  captionTitle: colors.victoria,
  intoColor: colors.charcoal4,
  TxtFilterSelect: colors.victoria,
  termName: colors.dove,
  hint: colors.silver,
  footerBackground: colors.smoke,
  tooltipBackground: colors.white,
  footerFontColor: colors.rock,
  gridLines: '0.5px solid #DBDBDB',
  pillBorder: '243646',
  pillColor: '243646',
  scheduleBorder: `1px solid ${colors.ash}`,
  ashBorder: `1px solid ${colors.ash}`,
  Intro5am: colors.fiveam,
  courseCardBorder: '1px solid #dedfe0',
  courseFeedbackColumnBg: colors.smoke,
  assessmentColumnBorder: '1px solid #e3e3e3',
  assessmentTopBorder: `1px solid ${colors.silver}`,
  AssessmentsListContainerBorder: `1px solid #bbb`,
  noteBackground: colors.smoke,
  announcementsBackground: '#fafafa',
  announcementsHeaderBackground: colors.white,
  selectBackground: colors.white,
  navBackground: colors.white,
  selectHighlight: '#f1f1f1',
  selectBorder: `1px solid ${colors.rock}`,
  reportHover: colors.smoke,
  phaseHover: '000',
  engagementColumnBg: colors.white,
  engagementColumnBorder: `1px solid ${colors.rock}`,
  engagementBorderWeekly: `1px solid ${colors.smoke}`,
  chartBlockBorder: '0.5px solid #DBDBDB',
  artifactBackground: colors.white,
  activityContainerBorder: `1px solid ${colors.rock}`,
  lineHeight3: '1px',
  rockLine: colors.rock,
  mentorCourseGradient:
    'linear-gradient(90deg,rgba(245,245,245,0) 0%, #F8F8F8 100%)',
  studentCourseGradient:
    'linear-gradient(90deg,rgba(245,245,245,0) 0%, white 100%)',
  headerShadow: '0 2px 7px 0 rgba(0, 0, 0, 0.04)',
  targetDateText: '#1C3749',
  calendarBorder: '1px solid rgba(0,0,0,0.11)',
  calendarBackground:
    'linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 9px, rgba(255,255,255,1) 18px, rgba(255,255,255,1) 100%)',
  tooltipBorder: `8px solid ${colors.smoke}`,
  sidePanelDividerBorder: '1px solid #e9e9e9',
  questDetailsBackground: colors.smoke,
  aluminumText: colors.aluminum,
  blackText: colors.black,
  cardHeader: colors.smoke,
  ash: colors.ash,
  sidebarNoteFade:
    'linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0.95) 20px, rgba(255, 255, 255, 0) 100% )',
  courseWidgetBorder: '0.86px solid rgba(0,0,0,0.11)',
  notificationWidgetBorder: '#E7E7E7 1px solid !important',
  masterSelectBorder: '1px rgb(204, 204, 204) solid',
  modalBackground: '#f8f8f8',
  notificationHighlight: '#fff6e2',
  skillBackground: colors.focusSkillBlue,
  mentorBackground: '#F5F5F5',
  chartBackground: '#F0F0F0',
  engagementDashed: `1px dashed ${colors.rock}`,
  activityNavigationSelected: colors.victoria,
  activityNavigationUnselected: colors.rock,
  masteryBorder: '1px #EFEFEF',
  svgFilter: 'none',
  smileChartBg: 'transparent',
  axisStroke: 'rgba(0,0,0,0.11)',
  journeyExpandBg: colors.white,
  artifactTooltipBorderColor: '#bbb',
  learningSkillIconBg: colors.white,
  learningSKillGraphLines: 'rgba(0,0,0,0.11)',
  chartGridLines: colors.silver,
  phaseIndicator: colors.dove,
  activityColor: '#666666',
  engagementCurrentWeek: '#F0F0F080',
  engagementContainer: 'none',
  readIndicator: 'rgba(255, 174, 0, 0.7)',
  noteText: '#666',
  maxContrast: colors.black,
  highContrastText: colors.charcoal2,
  chartToolTipDivider: '1px solid rgba(0, 0, 0, 0.11)',
  developingColor: '#90B1C3',
  onTrackColor: colors.slate,
  excellingColor: '#15416B'
}

const dark = {
  style: 'dark',
  text: 'rgba(255,255,255, 0.8)',
  Intro5am: 'rgba(255,255,255, 0.8)',
  h1: '#FFFFFF',
  h2: '#FFFFFF',
  h3: '#FFFFFF',
  h4: '#FFFFFF',
  h5: '#FFFFFF',
  h6: '#FFFFFF',
  p1: 'rgba(255,255,255, 0.8)',
  p2: 'rgba(255,255,255, 0.8)',
  p3: 'rgba(255,255,255, 0.8)',
  footerFontColor: 'rgba(255,255,255, 0.8)',
  captionTitle: 'rgba(255,255,255, 0.8)',
  caption1color: 'rgba(255,255,255, 0.8)',
  caption2color: 'rgba(255,255,255, 0.8)',
  caption3color: 'rgba(255,255,255, 0.8)',
  caption4color: 'rgba(255,255,255, 0.8)',
  caption5color: 'rgba(255,255,255, 0.8)',
  caption6color: 'rgba(255,255,255, 0.8)',
  caption7color: 'rgba(255,255,255, 0.8)',
  TxtFilterSelect: 'rgba(255,255,255, 0.8)',
  targetDateText: 'rgba(255,255,255)',
  hint: 'rgba(255,255,255, 0.8)',
  mentorCard: '#F8F8F8',
  cardBackground: '#172029',
  announcementsBackground: '#172029',
  announcementsHeaderBackground: '#172029',
  navBackground: '#172029',
  selectBackground: '#2C333B',
  selectHighlight: 'rgba(255,255,255,0.05)',
  footerBackground: '#131D26',
  gridLines: '2px solid #0B151E',
  pillBorder: 'FFFFFF33',
  pillColor: '5BADFF',
  scheduleBorder: '2px solid #0B151E',
  courseCardBorder: '2px solid #0B151E',
  assessmentColumnBorder: '2px solid #0B151E',
  courseFeedbackColumnBg: 'rgba(255,255,255,0.05)',
  assessmentTopBorder: '2px solid #0B151E',
  AssessmentsListContainerBorder: '2px solid #0B151E',
  noteBackground: 'transparent',
  reportHover: '#253039',
  phaseHover: 'rgba(255,255,255, 0.8)',
  engagementColumnBg: 'rgba(255,255,255,0.05)',
  engagementColumnBorder: '2px solid #0B151E',
  engagementBorderWeekly: '2px solid #0B151E',
  chartBlockBorder: '2px solid #0B151E',
  termName: 'rgba(255,255,255, 0.8)',
  artifactBackground: 'rgba(255,255,255,0.05)',
  activityContainerBorder: '2px solid #0B151E',
  lineHeight3: '3px',
  rockLine: '#253039',
  mentorCourseGradient:
    'linear-gradient(90deg,rgba(245,245,245,0) 0%, #253039 100%)',
  studentCourseGradient:
    'linear-gradient(90deg,rgba(245,245,245,0) 0%, #253039 100%)',
  headerShadow: '0 1px 13px 0 #000000',
  calendarBorder: '2px solid #0B151E',
  calendarBackground: '#172029',
  tooltipBorder: '8px solid #0B151E',
  sidePanelDividerBorder: '2px solid #0B151E',
  ashBorder: '2px solid #0B151E',
  questDetailsBackground: `#17202`,
  selectBorder: `none`,
  aluminumText: 'rgba(255,255,255, 0.8)',
  blackText: 'rgba(255,255,255, 0.8)',
  intoColor: 'rgba(255,255,255, 0.8)',
  cardHeader: '#1A242E',
  ash: '#0B151E',
  sidebarNoteFade:
    'linear-gradient(0deg, #2C333B 1%, rgba(255, 255, 255, 0.2) 10px, rgba(255, 255, 255, 0) 100% )',
  courseWidgetBorder: '2px solid #0B151E',
  notificationWidgetBorder: '2px solid #0B151E !important',
  masterSelectBorder: '2px solid #0B151E',
  modalBackground: '#172029',
  notificationHighlight: 'rgba(255,255,255, 0.4)',
  skillBackground: '#203143',
  mentorBackground: 'rgba(255,255,255,0.05)',
  chartBackground: 'rgba(255,255,255,0.05)',
  engagementDashed: '2px dashed #0B151E',
  activityNavigationSelected: colors.rock,
  activityNavigationUnselected: colors.victoria,
  tooltipBackground: '#131D26',
  masteryBorder: '2px solid #0B151E',
  svgFilter:
    'invert(49%) sepia(8%) saturate(194%) hue-rotate(170deg) brightness(123%) contrast(119%)',
  smileChartBg: '#2C333B',
  axisStroke: '#0B151E',
  journeyExpandBg: 'rgba(255,255,255, 0.4)',
  artifactTooltipBorderColor: '#2C333B',
  learningSkillIconBg: 'rgba(255,255,255,0.1)',
  learningSKillGraphLines: '#0B151E',
  chartGridLines: '#0B151E',
  phaseIndicator: colors.white,
  activityColor: colors.silver,
  engagementCurrentWeek: '#20272d',
  engagementContainer: '#F0F0F010',
  readIndicator: '#FFBE00',
  noteText: colors.white,
  maxContrast: colors.white,
  highContrastText: colors.white,
  chartToolTipDivider: '2px solid #0B151E',
  developingColor: colors.white,
  onTrackColor: colors.white,
  excellingColor: colors.white
}

export { light, dark }
